export default __webpack_public_path__ + "static/media/payment.3e1ce6a1.png";